export interface OdItem {
  id: number;
  name: string;
  backgroundColor?: string;
  imgPath?: string;
}

export interface courseItem {
  id: number;
  name: string;
  odList?: OdItem[];
  backgroundColor?: string;
  imgPath?: string;
}

export const courseMap: courseItem[] = [
  {
    id: 0,
    name: "",
    backgroundColor: "light-grey",
    odList: [
      {
        id: 0,
        name: "",
        imgPath: "./assets/images/homepage/corso-manuale-generico.svg",
      },
    ],
    imgPath: "./assets/images/homepage/corso-generico.svg",
  },
  {
    id: 8,
    name: "Negozio - Manuali",
    backgroundColor: "",
    odList: [
      {
        id: 38,
        name: "Manuale Interattivo",
        imgPath: "./assets/images/course-page/manuale-interattivo.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-manuale-generico.svg",
  },
  {
    id: 9,
    name: "PGS - Manuali",
    backgroundColor: "",
    odList: [
      {
        id: 40,
        name: "Manuale Interattivo",
        imgPath: "./assets/images/course-page/manuale-interattivo.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-manuale-generico.svg",
  },
  {
    id: 10,
    name: "Snaipay PVR - Manuali",
    backgroundColor: "",
    odList: [
      {
        id: 42,
        name: "Manuale Interattivo",
        imgPath: "./assets/images/course-page/manuale-interattivo.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-manuale-generico.svg",
  },
  {
    id: 11,
    name: "VLT - Manuali",
    backgroundColor: "",
    odList: [
      {
        id: 43,
        name: "Manuale Interattivo",
        imgPath: "./assets/images/course-page/manuale-interattivo.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-manuale-generico.svg",
  },
  {
    id: 12,
    name: "Noleggiatore - Manuali",
    backgroundColor: "pink",
    odList: [
      {
        id: 45,
        name: "Manuale Noleggiatore",
        imgPath: "./assets/images/course-page/manuale-awp.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-manuale-generico.svg",
  },
  {
    id: 13,
    name: "Amministratore - Manuali",
    backgroundColor: "",
    odList: [
      {
        id: 46,
        name: "Manuale Interattivo",
        imgPath: "./assets/images/course-page/manuale-interattivo.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-manuale-generico.svg",
  },
  {
    id: 14,
    name: "Negozio - Video",
    backgroundColor: "",
    odList: [
      {
        id: 39,
        name: "Video Tutorial",
        imgPath: "./assets/images/course-page/video-tutorial.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-video-generico.svg",
  },
  {
    id: 15,
    name: "PGS - Video",
    backgroundColor: "",
    odList: [
      {
        id: 41,
        name: "Video Tutorial",
        imgPath: "./assets/images/course-page/video-tutorial.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-video-generico.svg",
  },
  {
    id: 17,
    name: "VLT - Video",
    backgroundColor: "",
    odList: [
      {
        id: 44,
        name: "Video Tutorial",
        imgPath: "./assets/images/course-page/video-tutorial.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-video-generico.svg",
  },
  {
    id: 19,
    name: "Amministratore - Video",
    backgroundColor: "",
    odList: [
      {
        id: 48,
        name: "Video Tutorial",
        imgPath: "./assets/images/course-page/video-tutorial.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-video-generico.svg",
  },
  {
    id: 20,
    name: "Snaipay PVR - Video",
    backgroundColor: "",
    odList: [
      {
        id: 49,
        name: "Video Tutorial",
        imgPath: "./assets/images/course-page/video-tutorial.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-video-generico.svg",
  },
  {
    id: 21,
    name: "Dipendenti Snaitech - Manuali",
    backgroundColor: "",
    odList: [
      {
        id: 46,
        name: "Manuale Interattivo",
        imgPath: "./assets/images/course-page/manuale-interattivo.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-manuale-generico.svg",
  },
  {
    id: 22,
    name: "Dipendenti Snaitech - Video",
    backgroundColor: "",
    odList: [
      {
        id: 48,
        name: "Video Tutorial",
        imgPath: "./assets/images/homepage/corso-video-generico.svg",
      },
    ],
    imgPath: "./assets/images/homepage/corso-video-generico.svg",
  },
  {
    id: 23,
    name: "Amministratore - Corso Snaipay Wallet",
    backgroundColor: "violet",
    odList: [
      {
        id: 52,
        name: "Amministratore - Snaipay Wallet - DO",
        imgPath: "./assets/images/course-page/snaipay-video-corso.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-generico.svg",
  },
  {
    id: 24,
    name: "Amministratore - Corso Snaipay",
    backgroundColor: "violet",
    odList: [
      {
        id: 53,
        name: "Corso Snaipay - 1",
        imgPath: "./assets/images/course-page/snaipay-video-corso.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-generico.svg",
  },
  {
    id: 25,
    name: "Dipendenti Snaitech - Corso Snaipay",
    backgroundColor: "violet",
    odList: [
      {
        id: 54,
        name: "Corso Snaipay per Dipendenti Snaitech",
        imgPath: "./assets/images/course-page/snaipay-video-corso.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-generico.svg",
  },
  {
    id: 26,
    name: "Negozio - Corso Snaipay",
    backgroundColor: "violet",
    odList: [
      {
        id: 55,
        name: "Corso Snaipay per Negozio",
        imgPath: "./assets/images/course-page/snaipay-video-corso.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-generico.svg",
  },
  {
    id: 17,
    name: "PGS - Corso Snaipay",
    backgroundColor: "violet",
    odList: [
      {
        id: 56,
        name: "Corso Snaipay per PGS",
        imgPath: "./assets/images/course-page/snaipay-video-corso.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-generico.svg",
  },
  {
    id: 28,
    name: "Snaipay PVR - Corso Snaipay",
    backgroundColor: "violet",
    odList: [
      {
        id: 57,
        name: "Corso Snaipay per Snaipay PVR",
        imgPath: "./assets/images/course-page/snaipay-video-corso.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-generico.svg",
  },
  {
    id: 29,
    name: "VLT - Corso Snaipay",
    backgroundColor: "violet",
    odList: [
      {
        id: 58,
        name: "Corso Snaipay per VLT",
        imgPath: "./assets/images/course-page/snaipay-video-corso.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-generico.svg",
  },
  {
    id: 30,
    name: "HR Amministratore - Antiriclaggio (manuali)",
    backgroundColor: "green",
    odList: [
      {
        id: 59,
        name: "Antiriciclaggio e lotta al finanziamento al terrorismo - 0",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 60,
        name: "Antiriciclaggio e lotta al finanziamento al terrorismo - 1",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 61,
        name: "Antiriciclaggio e lotta al finanziamento al terrorismo - 2",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 62,
        name: "Antiriciclaggio e lotta al finanziamento al terrorismo - 3",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 63,
        name: "Antiriciclaggio e lotta al finanziamento al terrorismo - 4",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 64,
        name: "Antiriciclaggio e lotta al finanziamento al terrorismo - 5",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 65,
        name: "Antiriciclaggio e lotta al finanziamento al terrorismo - Test",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-manuale-generico.svg",
  },
  {
    id: 31,
    name: "Dipendenti Snaitech - Antiriciclaggio e lotta al finanziamento al terrorismo - 2022",
    backgroundColor: "green",
    odList: [
      {
        id: 59,
        name: "Antiriciclaggio e lotta al finanziamento al terrorismo - 0",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 60,
        name: "Antiriciclaggio e lotta al finanziamento al terrorismo - 1",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 61,
        name: "Antiriciclaggio e lotta al finanziamento al terrorismo - 2",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 62,
        name: "Antiriciclaggio e lotta al finanziamento al terrorismo - 3",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 63,
        name: "Antiriciclaggio e lotta al finanziamento al terrorismo - 4",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 64,
        name: "Antiriciclaggio e lotta al finanziamento al terrorismo - 5",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 65,
        name: "Antiriciclaggio e lotta al finanziamento al terrorismo - Test",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-manuale-generico.svg",
  },
  {
    id: 32,
    name: "Dipendenti Snaitech - Responsabilità da reato degli enti - 2022",
    backgroundColor: "",
    odList: [
      {
        id: 66,
        name: "Responsabilità da reato degli enti - 0",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 67,
        name: "Responsabilità da reato degli enti - 1",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 68,
        name: "Responsabilità da reato degli enti - 2",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 69,
        name: "Responsabilità da reato degli enti - 3",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 70,
        name: "Responsabilità da reato degli enti - 4",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 71,
        name: "Responsabilità da reato degli enti - 5",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 72,
        name: "Responsabilità da reato degli enti - 6",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 73,
        name: "Responsabilità da reato degli enti - 7",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 74,
        name: "Responsabilità da reato degli enti - 8",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 75,
        name: "Responsabilità da reato degli enti - 9",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 76,
        name: "Responsabilità da reato degli enti - 10",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 77,
        name: "Responsabilità da reato degli enti - 11",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 78,
        name: "Responsabilità da reato degli enti - 12",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 79,
        name: "Responsabilità da reato degli enti - 13",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 80,
        name: "Responsabilità da reato degli enti - Test",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-manuale-generico.svg",
  },
  {
    id: 33,
    name: "Negozio - Corso Snaipay Wallet",
    backgroundColor: "violet",
    odList: [
      {
        id: 81,
        name: "Corso Snaipay Wallet per Negozio",
        imgPath: "./assets/images/course-page/snaipay-video-corso.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-generico.svg",
  },
  {
    id: 34,
    name: "PGS - Corso Snaipay Wallet",
    backgroundColor: "violet",
    odList: [
      {
        id: 82,
        name: "Corso Snaipay Wallet per PGS",
        imgPath: "./assets/images/course-page/snaipay-video-corso.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-generico.svg",
  },
  {
    id: 35,
    name: "Snaipay PVR - Corso Snaipay Wallet",
    backgroundColor: "violet",
    odList: [
      {
        id: 83,
        name: "Corso Snaipay Wallet per Snaipay PVR",
        imgPath: "./assets/images/course-page/snaipay-video-corso.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-generico.svg",
  },
  {
    id: 36,
    name: "VLT - Corso Snaipay Wallet",
    backgroundColor: "violet",
    odList: [
      {
        id: 84,
        name: "Corso Snaipay Wallet per VLT",
        imgPath: "./assets/images/course-page/snaipay-video-corso.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-generico.svg",
  },
  {
    id: 37,
    name: "Dipendenti Snaitech - Corso Snaipay Wallet",
    backgroundColor: "violet",
    odList: [
      {
        id: 85,
        name: "Corso Snaipay Wallet per Dipendenti Snaitech",
        imgPath: "./assets/images/course-page/snaipay-video-corso.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-generico.svg",
  },
  {
    id: 38,
    name: "Amministratore - Corso SN",
    backgroundColor: "",
    odList: [],
    imgPath: "./assets/images/homepage/corso-generico.svg",
  },
  {
    id: 39,
    name: "Amministratore - Informatori",
    backgroundColor: "medium-grey",
    odList: [
      {
        id: 87,
        name: "Amministratore - Informatori",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-generico.svg",
  },
  {
    id: 40,
    name: "Dipendenti Snaitech - Informatori",
    backgroundColor: "medium-grey",
    odList: [
      {
        id: 88,
        name: "Dipendenti Snaitech - Informatori",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-generico.svg",
  },
  {
    id: 41,
    name: "Negozio - Informatori",
    backgroundColor: "medium-grey",
    odList: [
      {
        id: 89,
        name: "Negozio - Informatori",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-generico.svg",
  },
  {
    id: 42,
    name: "Noleggiatore - Informatori",
    backgroundColor: "medium-grey",
    odList: [
      {
        id: 90,
        name: "Noleggiatore - Informatori",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-generico.svg",
  },
  {
    id: 43,
    name: "PGS - Informatori",
    backgroundColor: "medium-grey",
    odList: [
      {
        id: 91,
        name: "PGS - Informatori",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-generico.svg",
  },
  {
    id: 44,
    name: "Snaipay PVR - Informatori",
    backgroundColor: "medium-grey",
    odList: [
      {
        id: 92,
        name: "Snaipay PVR - Informatori",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-generico.svg",
  },
  {
    id: 45,
    name: "VLT - Informatori",
    backgroundColor: "medium-grey",
    odList: [
      {
        id: 93,
        name: "VLT - Informatori",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-generico.svg",
  },
  {
    id: 46,
    name: "Compliance, Data Protection e Human Rights",
    backgroundColor: "",
    odList: [
      {
        id: 94,
        name: "Compliance Essentials",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 95,
        name: "Playtech contenuto aggiuntivo UK ABC",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 96,
        name: "Compliance Practice: Review Your Knowledge",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 97,
        name: "Human Rights & Modern Slavery",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 98,
        name: "Data Protection test",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 100,
        name: "Data Protection Essentials",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 101,
        name: "Dipendenti Snaitech - Human Rights, Compliance e Data Protection Essentials - LO6 - certificate",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-generico.svg",
  },
  {
    id: 47,
    name: "Formazione sulla sicurezza delle informazioni",
    backgroundColor: "",
    odList: [
      {
        id: 103,
        name: "Lezione Formazione sulla sicurezza delle informazioni",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 104,
        name: "Formazione sulla sicurezza delle informazioni - Test",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 105,
        name: "Formazione sulla sicurezza delle informazioni - Certificate",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-generico.svg",
  },
  {
    id: 48,
    name: "Gioco Responsabile",
    backgroundColor: "lilac",
    odList: [
      {
        id: 106,
        name: "Gioco Responsabile - Video Lezione 1",
        imgPath: "./assets/images/course-page/video-tutorial.png",
      },
      {
        id: 107,
        name: "Gioco Responsabile - Video Lezione 2",
        imgPath: "./assets/images/course-page/video-tutorial.png",
      },
      {
        id: 108,
        name: "Gioco Responsabile - Video Lezione 3",
        imgPath: "./assets/images/course-page/video-tutorial.png",
      },
      {
        id: 109,
        name: "Gioco Responsabile - Test",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 110,
        name: "Gioco Responsabile - Attestato",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso_gioco_responsabile.png",
  },
  {
    id: 50,
    name: "Corso Obblighi del punto vendita",
    backgroundColor: "lilac",
    odList: [
      {
        id: 119,
        name: "Amministratore- Obblighi Espositivi Punto Vendita - Video - DO01",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 125,
        name: "Amministratore- Obblighi Espositivi Punto Vendita - Attestato - DO02",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
    ],
    imgPath: "./assets/images/homepage/obblighi-espositivi.svg",
  },
  {
    id: 51,
    name: "Compliance, Data Protection e Human Rights 2023",
    backgroundColor: "",
    odList: [
      {
        id: 140,
        name: "Human Rigths, Compliance e Data Protection Essentials 2023 - Compliance Essentials",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 141,
        name: "Human Rigths, Compliance e Data Protection Essentials 2023 - Playtech contenuto aggiuntivo UK ABC",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 142,
        name: "Human Rigths, Compliance e Data Protection Essentials 2023 - Compliance Practice: Test",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 143,
        name: "Human Rigths, Compliance e Data Protection Essentials 2023 - Human Rights & Modern Slavery",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 144,
        name: "Human Rigths, Compliance e Data Protection Essentials 2023 - Data Protection Essentials",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 145,
        name: "Human Rigths, Compliance e Data Protection Essentials 2023 - Data Protection: Test",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 146,
        name: "Human Rigths, Compliance e Data Protection Essentials 2023 - Certificato",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-generico.svg",
  },
  {
    id: 52,
    name: "VLT - Corso Obblighi del punto vendita",
    backgroundColor: "",
    odList: [
      {
        id: 132,
        name: "VLT - Obblighi Espositivi Punto Vendita - Videocorso",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
    ],
    imgPath: "./assets/images/homepage/obblighi-espositivi.svg",
  },
  {
    id: 53,
    name: "PGS - Corso Obblighi del punto vendita",
    backgroundColor: "",
    odList: [
      {
        id: 134,
        name: "PGS - Obblighi Espositivi Punto Vendita - Videocorso",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
    ],
    imgPath: "./assets/images/homepage/obblighi-espositivi.svg",
  },
  {
    id: 54,
    name: "Negozio - Corso Obblighi del punto vendita",
    backgroundColor: "",
    odList: [
      {
        id: 133,
        name: "Negozio - Obblighi Espositivi Punto Vendita - Videocorso",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
    ],
    imgPath: "./assets/images/homepage/obblighi-espositivi.svg",
  },
  {
    id: 55,
    name: "Dipendenti - Corso Obblighi del punto vendita",
    backgroundColor: "",
    odList: [
      {
        id: 135,
        name: "Dipendenti - Obblighi Espositivi Punto Vendita - Videocorso",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
    ],
    imgPath: "./assets/images/homepage/obblighi-espositivi.svg",
  },
  {
    id: 56,
    name: "Compliance, Data Protection e Human Rights 2023 V2",
    backgroundColor: "",
    odList: [
      {
        id: 140,
        name: "Human Rigths, Compliance e Data Protection Essentials 2023 - Compliance Essentials",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 141,
        name: "Human Rigths, Compliance e Data Protection Essentials 2023 - Playtech contenuto aggiuntivo UK ABC",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 142,
        name: "Human Rigths, Compliance e Data Protection Essentials 2023 - Compliance Practice: Test",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 143,
        name: "Human Rigths, Compliance e Data Protection Essentials 2023 - Human Rights & Modern Slavery",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 144,
        name: "Human Rigths, Compliance e Data Protection Essentials 2023 - Data Protection Essentials",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 145,
        name: "Human Rigths, Compliance e Data Protection Essentials 2023 - Data Protection: Test",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
      {
        id: 146,
        name: "Human Rigths, Compliance e Data Protection Essentials 2023 - Certificato",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-generico.svg",
  },
  {
    id: 57,
    name: "Amministratore - B2B",
    backgroundColor: "lilac",
    odList: [
      {
        id: 147,
        name: "Amministratore - B2B - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      },
      {
        id: 148,
        name: "Amministratore - B2B - DO02",
        imgPath: "./assets/images/homepage/b2b-download.svg",
      },
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 58,
    name: "Negozio - B2B",
    backgroundColor: "lilac",
    odList: [
      {
        id: 147,
        name: "Amministratore - B2B - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      },
      {
        id: 148,
        name: "Amministratore - B2B - DO02",
        imgPath: "./assets/images/homepage/b2b-download.svg",
      },
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 59,
    name: "Dipendenti - B2B",
    backgroundColor: "lilac",
    odList: [
      {
        id: 147,
        name: "Amministratore - B2B - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      },
      {
        id: 148,
        name: "Amministratore - B2B - DO02",
        imgPath: "./assets/images/homepage/b2b-download.svg",
      },
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 60,
    name: "PGS - B2B",
    backgroundColor: "lilac",
    odList: [
      {
        id: 147,
        name: "Amministratore - B2B - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      },
      {
        id: 148,
        name: "Amministratore - B2B - DO02",
        imgPath: "./assets/images/homepage/b2b-download.svg",
      },
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 61,
    name: "Amministratore - Presentazione Iscrizione all'Albo",
    backgroundColor: "lilac",
    odList: [
      {
        id: 149,
        name: "Amministratore - Presentazione Iscrizione all'Albo - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      }
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 62,
    name: "Dipendenti - Presentazione Iscrizione all'Albo",
    backgroundColor: "lilac",
    odList: [
      {
        id: 150,
        name: "Negozio - Presentazione Iscrizione all'Albo - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      }
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 63,
    name: "Negozio - Presentazione Iscrizione all'Albo",
    backgroundColor: "lilac",
    odList: [
      {
        id: 151,
        name: "Negozio - Presentazione Iscrizione all'Albo - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      }
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 64,
    name: "PGS - Presentazione Iscrizione all'Albo",
    backgroundColor: "lilac",
    odList: [
      {
        id: 152,
        name: "PGS - Presentazione Iscrizione all'Albo - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      }
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 65,
    name: "SnaipayPVR - Presentazione Iscrizione all'Albo",
    backgroundColor: "lilac",
    odList: [
      {
        id: 153,
        name: "SnaipayPVR - Presentazione Iscrizione all'Albo - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      }
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 66,
    name: "VLT - Presentazione Iscrizione all'Albo",
    backgroundColor: "lilac",
    odList: [
      {
        id: 154,
        name: "VLT - Presentazione Iscrizione all'Albo - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      }
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 67,
    name: "Amministratore - Modello Organizzativo Snaitech",
    backgroundColor: "lilac",
    odList: [
      {
        id: 155,
        name: "Amministratore - Modello Organizzativo Snaitech - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      }
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 68,
    name: "Dipendenti - Modello Organizzativo Snaitech",
    backgroundColor: "lilac",
    odList: [
      {
        id: 156,
        name: "Dipendenti - Modello Organizzativo Snaitech - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      }
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 69,
    name: "Negozio - Modello Organizzativo Snaitech",
    backgroundColor: "lilac",
    odList: [
      {
        id: 157,
        name: "Negozio - Modello Organizzativo Snaitech - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      }
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 70,
    name: "PGS - Modello Organizzativo Snaitech",
    backgroundColor: "lilac",
    odList: [
      {
        id: 158,
        name: "PGS - Modello Organizzativo Snaitech - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      }
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 71,
    name: "SnaipayPVR - Modello Organizzativo Snaitech",
    backgroundColor: "lilac",
    odList: [
      {
        id: 159,
        name: "SnaipayPVR - Modello Organizzativo Snaitech - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      }
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 72,
    name: "VLT - Modello Organizzativo Snaitech",
    backgroundColor: "lilac",
    odList: [
      {
        id: 160,
        name: "VLT - Modello Organizzativo Snaitech - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      }
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 73,
    name: "Noleggiatore - Presentazione Iscrizione all'Albo",
    backgroundColor: "lilac",
    odList: [
      {
        id: 161,
        name: "Noleggiatore - Presentazione Iscrizione all'Albo - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      }
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 74,
    name: "Noleggiatore - Modello Organizzativo Snaitech",
    backgroundColor: "lilac",
    odList: [
      {
        id: 162,
        name: "Noleggiatore - Modello Organizzativo Snaitech - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      }
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 75,
    name: "Amministratore - Identificazione e gestione del giocatore problematico",
    backgroundColor: "lilac",
    odList: [
      {
        id: 163,
        name: "Amministratore - Identificazione e gestione del giocatore problematico - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      },
      {
        id: 164,
        name: "Amministratore - Identificazione e gestione del giocatore problematico - DO02",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      }
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 76,
    name: "Noleggiatore - Identificazione e gestione del giocatore problematico",
    backgroundColor: "lilac",
    odList: [
      {
        id: 165,
        name: "Noleggiatore - Identificazione e gestione del giocatore problematico - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      },
      {
        id: 171,
        name: "Noleggiatore - Identificazione e gestione del giocatore problematico - DO02",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      }
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 77,
    name: "VLT - Identificazione e gestione del giocatore problematico",
    backgroundColor: "lilac",
    odList: [
      {
        id: 166,
        name: "VLT - Identificazione e gestione del giocatore problematico - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      },
      {
        id: 172,
        name: "VLT - Identificazione e gestione del giocatore problematico - DO02",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      }
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 78,
    name: "SnaipayPVR - Identificazione e gestione del giocatore problematico",
    backgroundColor: "lilac",
    odList: [
      {
        id: 167,
        name: "SnaipayPVR - Identificazione e gestione del giocatore problematico - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      },
      {
        id: 173,
        name: "SnaipayPVR - Identificazione e gestione del giocatore problematico - DO02",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      }
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 79,
    name: "PGS - Identificazione e gestione del giocatore problematico",
    backgroundColor: "lilac",
    odList: [
      {
        id: 168,
        name: "PGS - Identificazione e gestione del giocatore problematico - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      },
      {
        id: 174,
        name: "PGS - Identificazione e gestione del giocatore problematico - DO02",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      }
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 80,
    name: "Negozio - Identificazione e gestione del giocatore problematico",
    backgroundColor: "lilac",
    odList: [
      {
        id: 169,
        name: "Negozio - Identificazione e gestione del giocatore problematico - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      },
      {
        id: 175,
        name: "Negozio - Identificazione e gestione del giocatore problematico - DO02",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      }
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 81,
    name: "Dipendenti - Identificazione e gestione del giocatore problematico",
    backgroundColor: "lilac",
    odList: [
      {
        id: 170,
        name: "Dipendenti - Identificazione e gestione del giocatore problematico - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      },
      {
        id: 176,
        name: "Dipendenti - Identificazione e gestione del giocatore problematico - DO02",
        imgPath: "./assets/images/course-page/lezione-generica.png",
      }
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 82,
    name: "Amministratore - Nuova Piattaforma di Affiliazione - Vademecum",
    backgroundColor: "lilac",
    odList: [
      {
        id: 177,
        name: "Nuova Piattaforma di Affiliazione - Vademecum - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      },
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 83,
    name: "Noleggiatore - Nuova Piattaforma di Affiliazione - Vademecum",
    backgroundColor: "lilac",
    odList: [
      {
        id: 178,
        name: "Nuova Piattaforma di Affiliazione - Vademecum - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      },
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 84,
    name: "VLT - Nuova Piattaforma di Affiliazione - Vademecum",
    backgroundColor: "lilac",
    odList: [
      {
        id: 179,
        name: "Nuova Piattaforma di Affiliazione - Vademecum - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      },
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 85,
    name: "SnaipayPVR - Nuova Piattaforma di Affiliazione - Vademecum",
    backgroundColor: "lilac",
    odList: [
      {
        id: 180,
        name: "Nuova Piattaforma di Affiliazione - Vademecum - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      },
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 86,
    name: "PGS - Nuova Piattaforma di Affiliazione - Vademecum",
    backgroundColor: "lilac",
    odList: [
      {
        id: 181,
        name: "Nuova Piattaforma di Affiliazione - Vademecum - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      },
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 87,
    name: "Negozio - Nuova Piattaforma di Affiliazione - Vademecum",
    backgroundColor: "lilac",
    odList: [
      {
        id: 182,
        name: "Nuova Piattaforma di Affiliazione - Vademecum - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      },
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 88,
    name: "Dipendenti - Nuova Piattaforma di Affiliazione - Vademecum",
    backgroundColor: "lilac",
    odList: [
      {
        id: 183,
        name: "Nuova Piattaforma di Affiliazione - Vademecum - DO01",
        imgPath: "./assets/images/homepage/b2b.svg",
      },
    ],
    imgPath: "./assets/images/homepage/b2b.svg",
  },{
    id: 89,
    name: "Amministratore - Pure Fun - Uniti contro il match-fixing",
    backgroundColor: "lilac",
    odList: [
      {
        id: 184,
        name: "Amministratore - Pure Fun - Uniti contro il match-fixing",
        imgPath: "./assets/images/homepage/corso-pure-fun.png",
      },
      {
        id: 185,
        name: "Amministratore - Pure Fun - Uniti contro il match-fixing",
        imgPath: "./assets/images/homepage/corso-pure-fun.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-pure-fun.png",
  },{
    id: 90,
    name: "Negozio - Pure Fun - Uniti contro il match-fixing",
    backgroundColor: "lilac",
    odList: [
      {
        id: 186,
        name: "Negozio - Pure Fun - Uniti contro il match-fixing",
        imgPath: "./assets/images/homepage/corso-pure-fun.png",
      },
      {
        id: 187,
        name: "Negozio - Pure Fun - Uniti contro il match-fixing",
        imgPath: "./assets/images/homepage/corso-pure-fun.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-pure-fun.png",
  },{
    id: 91,
    name: "PGS - Pure Fun - Uniti contro il match-fixing",
    backgroundColor: "lilac",
    odList: [
      {
        id: 188,
        name: "PGS - Pure Fun - Uniti contro il match-fixing",
        imgPath: "./assets/images/homepage/corso-pure-fun.png",
      },
      {
        id: 189,
        name: "PGS - Pure Fun - Uniti contro il match-fixing",
        imgPath: "./assets/images/homepage/corso-pure-fun.png",
      },
    ],
    imgPath: "./assets/images/homepage/corso-pure-fun.png",
  },
];



// WEBPACK FOOTER //
// ./src/app/coursesMap.ts